export default __webpack_public_path__ + "static/media/timeline.0dc8ca05.svg";